import stockAPI from "@/utility/api.js";
import Cookies from "js-cookie";

const state = {
  userInfo: {}
};

const getters = {
  userInfo(state) {
    const initData = {
      account: "xx",
      name: "xxxx",
      email: "xxx",
      phone: "123",
      seniority: 1,
      introduction: "hi"
    };
    if (!state.userInfo.email) {
      return initData;
    } else {
      return state.userInfo;
    }
  }
};

const mutations = {
  userInfo(state, res) {
    state.userInfo = Object.assign({}, res);
  }
};
const actions = {
  async fetchUserInfo({ commit }) {
    const loggedInInfoString = Cookies.get("chuenStock_loggedInInfo");
    const userId = JSON.parse(loggedInInfoString).id;
    const res = await stockAPI.GET(`api/user/${userId}`);
    if (res) {
      commit("userInfo", res);
      return Promise.resolve();
    }
  },
  updateUserInfo({ getters }) {
    const loggedInInfoString = Cookies.get("chuenStock_loggedInInfo");
    const userId = JSON.parse(loggedInInfoString).id;
    stockAPI.PUT(`api/user/${userId}`, getters.userInfo);
  },
  // eslint-disable-next-line no-unused-vars
  updateUserPassword({ state }, data) {
    const loggedInInfoString = Cookies.get("chuenStock_loggedInInfo");
    const userId = JSON.parse(loggedInInfoString).id;
    return stockAPI.PUT(`api/user/${userId}/password`, data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
